import './index.scss'
import React from 'react'

export default class ArticleLayout extends React.Component {
  state = this.props
  
  componentDidMount() {
    this.loadArticle()
    for (let img of $(this.refs.layoutWrap).find('img[data-src]')) {
      $(img).prop('src', $(img).data('src'))
    }
  }

  static articleUrl = (article) => {
    return `/s/${window.currentSite.guid}/p/${(article || {}).guid}`
  }

  loadArticle = () => {
    const query = `{
      article(guid: "${this.state.guid}") {
        guid title cover content_state published_at updated_at published
        prev_record {
          guid
        } 
        next_record {
          guid
        }
        related_records {guid title cover}
      }
    }`
    $.ajax({
      url: '/api/graphql',
      type: 'post',
      data: {
        query: query
      },
      dataType: 'json',
      headers: {
        Authorization: 'bearer xxx'
      },
      success: (response) => {
        this.setState(response.data.article)
      }
    })

  }

  prevRecordUrl = () => {
    return this.constructor.articleUrl(this.state.prev_record)
  }

  nextRecordUrl = () => {
    return this.constructor.articleUrl(this.state.next_record)
  }

  render() {
    return (
      <div className="layout-article-wrap" ref={'layoutWrap'}>
        <div className="container">
          <div className="row">
            <div className="col-sm-8">
              <div className="card">
                <div className="card-body article-info-wrap">
                  <div className="article-title">{this.props.title}</div>
                  {
                    this.props.cover &&
                    <div className="article-cover-wrap">
                      <img data-src={this.props.cover.url} src={this.props.cover.url + "?imageMogr2/format/jpeg"} />
                    </div>
                  }
                  <div className="article-actions-wrap">
                    <div className="row">
                      <div className="col-xs-6">
                        <button onClick={this.loadArticle} className="btn btn-block btn-primary">看车牌, 你懂的</button>
                      </div>
                      <div className="col-xs-6">
                        <div className="row">
                          <div className="col-xs-6">
                            {
                              this.state.prev_record &&
                              <a href={this.prevRecordUrl()} className="btn btn-block btn-outline-primary">上一张</a>
                            }
                            {
                              !this.state.prev_record &&
                              <button disabled={true} className="btn btn-block btn-outline-primary">上一张</button>
                            }
                          </div>
                          <div className="col-xs-6">
                            {
                              this.state.next_record &&
                              <a href={this.nextRecordUrl()} className="btn btn-block btn-outline-primary">下一张</a>
                            }
                            {
                              !this.state.next_record &&
                              <button disabled={true} className="btn btn-block btn-outline-primary">下一张</button>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="article-status-wrap">
                    <span>{`${Math.floor(Math.random() * 1000)} 喜欢`}</span>
                    <span className="pull-right">
                    <span>分享: </span>
                    <i className="fi fi-weixin"> </i>
                    <i className="fi fi-qq"> </i>
                    <i className="fi fi-qzone"> </i>
                    <i className="fi fi-weibo"> </i>
                  </span>
                  </div>
                </div>
              </div>

              {
                this.state.content_state &&
                <div className="card">
                  <div className="card-heading">车牌</div>
                  <div className="card-body">{ this.state.content_state }</div>
                </div>
              }
            </div>

            <div className="col-sm-4 sidebar-wrap">
              <div className="favorites-tips">
                <img style={{height: 20, marginRight: 15}} src="http://static.dian.in//assets/icons/ctrl-d.png" />
                <span>将司机GIF加入收藏夹，做老司机</span>
              </div>
              
              <div className="card">
                <div className="card-heading">司机GIF精选</div>
                <div className="card-body">
                  <div className="related-records-wrap">
                    {(this.state.related_records || []).map(page =>
                      <a className="related-item" href={this.constructor.articleUrl(page)} key={page.guid}>
                        {page.title}
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/app/site/structures/layout/article/index.js